export function isValidCity(city) {
  return city ? (city.length > 0 || "City is required") : "City is required"
}

export const rules = [isValidCity]
